import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';

import PaginatedList from 'src/components/ui/list/paginated-list';
import { Box, Typography, ListItem, ListItemText } from '@mui/material';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  const renderItem = (item, rowstyle) => (
    <>
      <ListItem
        divider={true}
        key={item.id}
        sx={rowstyle}
        onClick={() => onDetailClicked(item)}
      >
        <ListItemText sx={{ width: '30%', color: 'primary.main' }}>
          {item.created}
        </ListItemText>
        <ListItemText sx={{ width: '40%', textAlign: 'center' }}>
          {item.plae}
        </ListItemText>
        <ListItemText sx={{ width: '30%', textAlign: 'right' }}>
          {item.odo}
        </ListItemText>
      </ListItem>
    </>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items} // Pass fetchItems to load items per page
        loading={dataStore.loading} // Handle loading
        renderItem={renderItem} // Pass renderItem for each item rendering
        page={page} // Current page from dataSearch
        rowsPerPage={rowsPerPage} // Rows per page
        onPageChange={onPageChange} // Page change handler
        onRowsPerPageChange={onRowsPerPageChange} // Rows per page change
      >
        <Typography sx={{width: '30%'}} variant="body2">
          {t(appStr.txt_030)}
        </Typography>
        <Typography sx={{width: '40%', textAlign: 'center'}} variant="body2">
          {t(appStr.txt_034)}
        </Typography>
        <Typography sx={{ width: '30%', textAlign: 'right' }} variant="body2">
          ODO
        </Typography>
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
